//Timeout on error popups
export const errorTimeout: number = 2225;
